import axios from "axios";
import { message } from "antd";

const baseURL = 'https://cressa.in:9003/api/';

const publicUrls = [
    "user/login",
    "user/register",
    "user/verify",
    /^user\/verify(\?token=.+)?$/,
];

const axiosInstance = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const url = config.url || '';

        const isPublicUrl = publicUrls.some(pattern => {
            if (typeof pattern === 'string') {
                return pattern === url;
            } else {
                return pattern.test(url);
            }
        });

        // Set up headers object if it doesn't exist
        config.headers = config.headers || {};

        if (isPublicUrl) {
            // For public URLs, always send the essential token
            config.headers["x-access-token"] = "essential";
        } else {
            // For protected routes, use the auth token
            const authData = localStorage.getItem('auth0');
            const accessToken = authData ? (JSON.parse(authData)).access_token : null;
            if (accessToken) {
                config.headers['x-access-token'] = accessToken;
            } else {
                // If no token is available, default to essential
                config.headers["x-access-token"] = "essential";
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // Create a function to handle error messages
        const handleErrorMessage = (msg) => {
            setTimeout(() => {
                message.error(msg);
            }, 0);
        };

        if (error.response) {
            switch (error.response.status) {
                case 400:
                    // Handle 400 Bad Request
                    const errorData = error.response.data;
                    const errorMessage = typeof errorData === 'object' && errorData?.message
                        ? errorData.message
                        : typeof errorData === 'string'
                            ? errorData
                            : "Bad Request: The server could not understand the request";
                    handleErrorMessage(String(errorMessage));
                    break;
                case 401:
                    // Handle 401 Unauthorized
                    localStorage.removeItem("auth0");
                    handleErrorMessage("Session expired. Please log in again.");
                    window.location.href = '/login';
                    break;
                default:
                    // Handle other errors
                    const responseData = error.response.data;
                    handleErrorMessage(typeof responseData === 'string' ? responseData : "An error occurred");
            }
        } else if (error.request) {
            // The request was made but no response was received
            handleErrorMessage("No response received from server");
        } else {
            // Something happened in setting up the request that triggered an Error
            handleErrorMessage("Error setting up the request");
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;